<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{devolutionPrintModel.devolutionId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{devolutionPrintModel.devolutionId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nit -->
                  <label id="t-nit-empresa-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-nit-empresa' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-empresa-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.enterpriseNit}}</p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{devolutionPrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.branchName}}</p>

                  <!--Nombre Devolución -->
                  <p id="nombre-devolución-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.titleForm}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.branchPhone}}</p>

                  <!-- Fecha Devolución -->
                  <label id="t-fecha-devolucion-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-devolucion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-devolucion-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.dateDevolution | date: 'dd/MM/yyyy'}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{devolutionPrintModel.devolutionId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{devolutionPrintModel.costCenter}}</p>

                  <!-- Fecha Factura -->
                  <label id="t-fecha-factura-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-factura-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.dateInvoice| date: 'dd/MM/yyyy'}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-obra-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.constructionSiteAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.constructionSitePhone}}</p>

                  <!--Teléfono Alterno -->
                  <label id="t-telefono-obra-alt-{{devolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-obra-alt' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-alt-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.constructionSiteAlterPhone}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.clientName}}</p>

                  <!--Hora Llegada  -->
                  <label id="t-hora-llegada-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-hora-llegada' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-hora-llegada-{{devolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Hora Entrega  -->
                  <label id="t-hora-entrega-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-hora-entrega' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-hora-entrega-{{devolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Ciudad destino  -->
                  <label id="t-ciudad-destino-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{"t-ciudad-destino" | formatLabelPipe : elementsLabel}}</label>
                  <p id="ciudad-destino-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.destinityCity}}</p>

                  <!--Comodin 1  -->
                  <label id="t-comodin-1-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{"t-comodin-1" | formatLabelPipe : elementsLabel}}</label>
                  <p id="comodin-1-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.wildcard}}</p>

                  <!-- Comodin 2 -->
                  <label id="t-comodin-2-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{"t-comodin-2" | formatLabelPipe : elementsLabel}}</label>
                  <p id="comodin-2-{{ devolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{devolutionPrintModel.wildcard2}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-devolucion-{{devolutionPrintModel.devolutionId}}"
                  [columns]="columns" [data]="devolutionPrintModel.devolutionDetails" [idMap]="idMap"
                  [documentId]="devolutionPrintModel.devolutionId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!------------------------------------------------------- REPARACIONES ---------------------------------------------->
              <div *ngFor="let detail of devolutionPrintModel.devolutionDetails" class="container-repair mt-2">
                <p id="articulo-reparacion-{{detail.devolutionDetailId}}"
                  *ngIf="detail.devolutionRepairs && detail.devolutionRepairs.length != 0" (click)="clickTable($event)">
                  Reparaciones para {{detail.articleName}}:
                </p>
                <div class="mt-1" *ngIf="detail.devolutionRepairs && detail.devolutionRepairs.length != 0">
                  <app-custom-table-print id="reparaciones-{{detail.devolutionDetailId}}" [columns]="columnsRepairs"
                    [data]="detail.devolutionRepairs" [idMap]="idMapRepairs" [documentId]="detail.devolutionDetailId"
                    [footerVisible]="false" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                    (newIndexColumns)="onColumnReorderRepairs($event)"></app-custom-table-print>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Observaciones -->
          <div id="foot-{{devolutionPrintModel.devolutionId}}" class="foot mt-1 container-observations">
            <label id="t-observacion-devolucion-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()" *ngIf="devolutionPrintModel.printObservation">
              {{'t-observacion-devolucion' | formatLabelPipe : elementsLabel}}</label>
            <p id="observacion-devolucion-{{devolutionPrintModel.devolutionId}}" class="lh-sm"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
              *ngIf="devolutionPrintModel.printObservation">{{devolutionPrintModel.printObservation}}
            </p>

            <!-- Observaciones Sucursal -->
            <p id="observacion-sucursal-{{devolutionPrintModel.devolutionId}}" class="lh-sm observation-devolucion"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
              {{devolutionPrintModel.devolutionObservation}}</p>

            <!-- Transportador-->
            <p id="transportador-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{ devolutionPrintModel.transporter}}</p>
            <label id="t-transportador-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-transportador' | formatLabelPipe : elementsLabel}}</label>

            <!-- Valor Transporte -->
            <label id="t-valor-transporte-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-valor-transporte' | formatLabelPipe : elementsLabel}}</label>
            <p id="valor-transporte-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{devolutionPrintModel.transportValue | currency}}</p>

            <!-- Firma Transportador-->
            <p id="linea-firma-transportador-{{devolutionPrintModel.devolutionId}}" class="write-line"
              (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-firma-transportador-{{devolutionPrintModel.devolutionId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
              {{'t-linea-firma-transportador' | formatLabelPipe : elementsLabel}}</label>

            <!-- Firma Entrega-->
            <p id="linea-firma-entrega-{{devolutionPrintModel.devolutionId}}" class="write-line" (click)="onClick()"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-entrega-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-linea-entrega' | formatLabelPipe : elementsLabel}}</label>

            <!-- Firma Recibe-->
            <p id="linea-firma-recibe-{{devolutionPrintModel.devolutionId}}" class="write-line" (click)="onClick()"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-recibe-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-linea-recibe' | formatLabelPipe : elementsLabel}}</label>

            <!-- Firma Responsable-->
            <p id="linea-firma-responsable-{{devolutionPrintModel.devolutionId}}" class="write-line" (click)="onClick()"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-responsable-{{devolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-linea-responsable' | formatLabelPipe : elementsLabel}}</label>

          </div>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{devolutionPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>